import { nestApiClient } from './api-client';
import {
  CheckoutResponse,
  SubscriptionPlanResponse,
  UserSubscriptionPlanResponse,
} from '@wwe-portal/entities/subscription.type';

export const getSubscriptionPlans = () => {
  return nestApiClient.get<SubscriptionPlanResponse>('/subscription/plans');
};

export const getUserSubscriptionPlan = () => {
  return nestApiClient.post<UserSubscriptionPlanResponse>(
    '/subscription/user/plans'
  );
};

export const checkoutUpgradePlanSubscribe = (body: {
  planId: string;
  version: string;
  returnUrl: string;
}) => {
  return nestApiClient.post<CheckoutResponse>(
    '/subscription/token/plan/upgrade',
    body
  );
};

export const checkoutPlanUpdate = (body: {
  version: string;
  returnUrl: string;
}) => {
  return nestApiClient.post<CheckoutResponse>(
    '/subscription/token/user/info',
    body
  );
};

export const cancelPlanNonRenew = (subscriptionId: string) => {
  return nestApiClient.put(`/subscription/${subscriptionId}/cancel`);
};
